import styled, { css } from 'styled-components';
import { Typography } from '../typography';
import { smallScreenSize } from '../../hooks';

interface EmptyFilesMessageProps {
  gridColumn?: string;
}

export const EmptyFilesMessage = styled(Typography)<EmptyFilesMessageProps>`
  padding: 2.8rem;

  ${(props) =>
    props.gridColumn &&
    css`
      grid-column: ${props.gridColumn};
    `}

  @media (max-width: ${smallScreenSize}px) {
    background-color: var(--white);
    border-radius: var(--border-radius-6);
  }
`;
